import { render, staticRenderFns } from "./MechanismBasisEdit.vue?vue&type=template&id=3ef4850b&scoped=true"
import script from "./MechanismBasisEdit.vue?vue&type=script&lang=js"
export * from "./MechanismBasisEdit.vue?vue&type=script&lang=js"
import style0 from "./MechanismBasisEdit.vue?vue&type=style&index=0&id=3ef4850b&prod&scoped=true&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef4850b",
  null
  
)

export default component.exports